var _defs, _rect, _rect2, _rect3, _circle, _path, _circle2, _path2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 220",
    role: "img",
    "aria-label": "Image unavailable",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#dbeafe"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 220,
    rx: 18,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 268,
    height: 156,
    rx: 14,
    fill: "#ffffff",
    stroke: "#94a3b8",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 52,
    width: 188,
    height: 92,
    rx: 10,
    fill: "#f8fafc",
    stroke: "#cbd5e1",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 82,
    r: 11,
    fill: "#60a5fa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 128l34-30 24 20 24-20 32 30",
    fill: "none",
    stroke: "#64748b",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 54,
    r: 20,
    fill: "#fee2e2",
    stroke: "#ef4444",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226 54h20",
    stroke: "#ef4444",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 198,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "\r\n    Image Unavailable\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundImage);
export default __webpack_public_path__ + "static/media/not-found-image.63ce6f53a2650017edfe1f2b3dd95c23.svg";
export { ForwardRef as ReactComponent };